<template>
  <div class="row video-row">
    <div class="col-1">
      <div
        v-show="circletext && showVideoAdds"
        class="video-circle"
      >
        <span v-html="circletext" />
      </div>
    </div>
    <div class="col-10">
      <div class="video">
        <div id="player" />
      </div>
    </div>
    <div class="col-1">
      <div
        v-show="arrowtext && showVideoAdds"
        class="left-arrow"
      >
        <div class="up-arrow-text">
          {{ arrowtext }}
        </div>
        <img
          class="left-arrow"
          src="/build/images/RedLeftCurveArrow.png"
          alt="left arrow"
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    circletext: {
      type: String,
      default: null,
    },
    youtubeid: {
      type: String,
      default: null,
    },
    arrowtext: {
      type: String,
      default: null,
    },
  },

  data () {
    return {
      showVideoAdds: true,
      player: {},
      done: false,
    };
  },

  mounted () {
    const tag = document.createElement('script');

    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    let player;
    window.onYouTubeIframeAPIReady = () => {
      player = new YT.Player('player', {
        height: '100%',
        width: '100%',
        videoId: this.youtubeid,
        events: {
          onStateChange: onPlayerStateChange,
        },
      });
    };

    window.onPlayerStateChange = (event) => {
      this.stateChanged(event);
    };
  },

  methods: {
    stateChanged (event) {
      if (event.data == YT.PlayerState.PLAYING && ! this.done) {
        this.done = true;
      }

      if (this.done && event.data === 1) {
        this.showVideoAdds = false;
      } else if (this.done && event.data === 2) {
        this.showVideoAdds = true;
      }
    },
  },
};
</script>
